import firebase from './firebase';

export default new function Auth() {
  
  this.connect = (callBack) => {
    //console.log('In connect');
    
    firebase.auth().onAuthStateChanged(authData => {
      //console.log('In authChanged...');
      //console.log(authData);
      if(authData) {
        this.authData = { authenticated: true, ...authData};
      } else {
        this.authData = { authenticated: false, ...authData};
      }
      callBack( this.authData, firebase.database);
    });
  }
  
  this.signIn = function(prov, email, pwd) {
    
    if(prov === 'google') {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithRedirect(provider).then(function(result) {
        //console.log(result);
      });
    }

    if(prov === 'email') {
      firebase.auth().signInWithEmailAndPassword(email, pwd).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorCode, errorMessage);
        // ...
      });
    }
    
  }

  this.signUp = function(prov, email, pwd) {

    if(prov === 'email') {

      firebase.auth().createUserWithEmailAndPassword(email, pwd).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorCode, errorMessage);
        // ...
      });

    }
    
  }
  
  this.signOut = (callBack) => {
    if (typeof callBack !== 'function') {
      callBack = () => {};
    }
    if (firebase.auth().currentUser) {
      // current user can be removed from db
      firebase.auth().signOut().then(callBack);
    } else {
      //console.warn('signOut: invalid user');
    }
  }
  
}();


// WEBPACK FOOTER //
// ./src/Auth.js